/**
 * Guarantees at most one hover preview is playing anywhere on the page.
 *
 * A pointer crossing the shelf can leave more than one card mid-start — `mouseleave` on one
 * card is not guaranteed to fire before `mouseenter` on the next, and each card carries its
 * own intent-delay timer. Three concurrent HLS streams on a public marketing page is a real
 * bandwidth spike, so whoever starts last wins and everyone else is torn down.
 *
 * Module-level singleton with closured state, matching the house service idiom.
 */
let stopActivePreview: (() => void) | undefined

export const hoverPreviewCoordinator = {
  /** Take the single preview slot, stopping whatever held it. */
  claim: (stop: () => void): void => {
    if (stopActivePreview && stopActivePreview !== stop) stopActivePreview()
    stopActivePreview = stop
  },

  /** Give the slot back, if this caller still holds it. */
  release: (stop: () => void): void => {
    if (stopActivePreview === stop) stopActivePreview = undefined
  },
}
